import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Shared Pages
import Home from "./pages/shared/Home";
import Profile from "./pages/shared/Profile";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ResetPassword from "./pages/auth/ResetPassword";

// Auth Pages
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import TeacherDetail from "./pages/auth/TeacherDetail";

// Teacher Pages
import TeacherLayout from "./layouts/TeacherLayout"; // Must contain <Outlet />
import TeacherDashboard from "./pages/teacher/Dashboard";
import Wallet from "./pages/teacher/Wallet";
import CreateClass from "./pages/teacher/CreateClass";
import PostMaterial from "./pages/teacher/PostMaterial";
import ViewRatings from "./pages/teacher/ViewRatings";
import EditProfile from "./pages/teacher/EditProfile";

import Referral from "./pages/teacher/Referral";



// Student Pages
import Dashboard from "./pages/student/Dashboard";
import ViewMaterials from "./pages/student/ViewMaterials";
import RateTeacher from "./pages/student/RateTeacher";
import JoinClass from "./pages/student/JoinClass";
import Wallets from "./pages/student/Wallets";

// Payment Pages
import Pay from "./Pay";
import PaymentSuccess from "./PaymentSuccess";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public */}
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/teacherDetail" element={<TeacherDetail />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/profile/:id" element={<Profile />} />
        <Route path="/pay" element={<Pay />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />

        {/* Teacher Protected Layout */}
        <Route path="/teacher" element={<TeacherLayout />}>
          <Route path="dashboard" element={<TeacherDashboard />} />
          <Route path="wallet" element={<Wallet />} />
          <Route path="create-class" element={<CreateClass />} />
          <Route path="post-material" element={<PostMaterial />} />
          <Route path="ratings" element={<ViewRatings />} />
          <Route path="edit-profile" element={<EditProfile />} />
          <Route path="referral" element={<Referral />} />

        </Route>

        {/* Student Routes */}
        <Route path="/student/dashboard" element={<Dashboard />} />
        <Route path="/student/view-materials" element={<ViewMaterials />} />
        <Route path="/student/rate-teacher" element={<RateTeacher />} />
        <Route path="/student/join-class" element={<JoinClass />} />
          <Route path="/student/wallets" element={<Wallets/>} />
        {/* Remove wildcard redirect for development */}
        {/* <Route path="*" element={<Navigate to="/" />} /> */}
      </Routes>
    </BrowserRouter>
  );
}

export default App;







